/* ═══════════════════════════════════════════════════════
   FIREBASE CONFIG — SpellWise Kids
   ───────────────────────────────────────────────────────
   This file is separate from App.js so your Firebase
   settings are never overwritten when the app is updated.

   HOW TO FIND THESE VALUES:
   Firebase Console → Project Settings → Your Apps → SDK setup
═══════════════════════════════════════════════════════ */
export const FIREBASE_CONFIG = {
  apiKey:            "AIzaSyDtk3lSOZMaJzl5X_i04a-JOZjAqVsXp7U",
  authDomain:        "spellwisekids.firebaseapp.com",
  databaseURL:       "https://spellwisekids-default-rtdb.asia-southeast1.firebasedatabase.app/",
  projectId:         "spellwisekids",
  storageBucket:     "spellwisekids.firebasestorage.app",
  messagingSenderId: "854196473237",
  appId:             "1:854196473237:web:6c79e8b59da7e1be623a9c",
};
